import { render } from "./preview.widget.vue?vue&type=template&id=14f2cffa&scoped=true&ts=true"
import script from "./preview.widget.vue?vue&type=script&lang=ts"
export * from "./preview.widget.vue?vue&type=script&lang=ts"

import "./preview.widget.vue?vue&type=style&index=0&id=14f2cffa&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f2cffa"]])

export default __exports__